<template>
	<div class="model1">
		<div class="model1_box1">
			<downPull
				class="downPull"
				v-for="(item, index) in tagsLists"
				:key="index"
				:tags="item.tags"
				:tagTitle="item.tagTitle"
				:selected-tags="selectedTags"
				@tag-click="handleTagClick"
			></downPull>
			<div class="selected-tags">
				<div class="tagListTitle">已选：</div>
				<div>
					<el-tag
						v-for="(tag, index) in selectedTags"
						:key="index"
						v-if="tag.name !== '不限'"
						:closable="true"
						@close="removeTag(tag)"
						type="warning"
					>
						{{ tag.name }}
					</el-tag>
				</div>
			</div>
		</div>
		<div class="model1_box2">
			<!-- 文章列表部分 -->
			<div class="m1_info_box">
				<ul class="m1_info_ul" style="margin-top:20px;">
					<li v-for="(item, index) in dataList" :key="index">
						<a
							class="m1_info_li_l"
							:href="
								'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx?docid=' +
									item.code.split('_')[1] +
									'&leafid=' +
									item.leafid
							"
							target="_blank"
						>
							<h6>{{ item.deliveddate | subData2 }}</h6>
							<span>{{ item.deliveddate | subData1 }}</span>
						</a>
						<a
							class="m1_info_li_r"
							:href="
								'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx?docid=' +
									item.code.split('_')[1] +
									'&leafid=' +
									item.leafid
							"
							target="_blank"
						>
							<h6
								v-html="
									item.title.replace(
										/<\/?(div|p|span|h3|h6|a)[^>]*>/g,
										''
									)
								"
							></h6>
							<span
								v-html="
									item.summary.replace(
										/<\/?(div|p|span|h3|h6|a)[^>]*>/g,
										''
									)
								"
							></span>
						</a>
					</li>
					<el-empty
						v-if="dataList.length <= 0 && loading == false"
						description="暂无数据!"
					></el-empty>
					<el-empty
						v-if="loading == true"
						description="加载中!"
					></el-empty>
				</ul>
				<div class="pagination_box">
					<el-pagination
						v-if="dataList.length > 0"
						background
						@current-change="handleCurrentChange"
						:current-page="currentPage"
						:page-size="pagesize"
						layout="total, prev, pager, next, jumper"
						:total="total"
					>
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import api from '@/../static/common/api/api.js';
import magic from '@/../static/common/magic.js';
import $ from 'jquery';
import echarts from 'echarts';
import downPull from './downPull.vue';

export default {
	// 国际概览 ——带多条件查询
	props: ['currentChoose', 'treeString'],
	components: { downPull },
	data() {
		return {
			dateRaneg: [], //日期
			startDate: '', //日历开始时间
			endDate: '', //日历结束时间
			dataType: '', //时间选项 0是 一周 1 是一个月 2 是一年 不限 ''
			currentPage: 1, //当前页
			total: 0, //总页数
			pagesize: 10, //每页条数
			loading: false, //表格加载
			dataList: [], //文章列表数据
			areaData: [], //地区数据
			chooseArea: [], //当前展示国家集合
			keyword: '', //当前选中的地区或者国家
			tagsLists: [],
			selectedTags: [
				{ name: '不限', type: 'country' },
				{ name: '不限', type: 'province' },
				{ name: '不限', type: 'year' },
				{ name: '不限', type: 'industry' },
			], // 初始化选中"不限"
		};
	},
	watch: {
		// currentChoose(val) {
		// 	this.currentPage = 1;
		// 	this.keyword = '';
		// 	this.dataType = ''; //时间初始化
		// 	this.fetchDataList(val); //获取文章列表

		// 	$('.m1_top_1 span').removeClass('active');
		// 	$('.m1_top_1 span')
		// 		.eq(0)
		// 		.addClass('active');

		// 	$('.m1_top_2 span').removeClass('active');
		// 	$('.m1_top_2 span')
		// 		.eq(0)
		// 		.addClass('active');

		// 	$('.m1_top_3 span').removeClass('active');
		// 	$('.m1_top_3 span')
		// 		.eq(0)
		// 		.addClass('active');
		// },
		treeString: {
			handler(to) {
				this.fetchDataList();
			},
			immediate: true,
		},
		// treeString(val) {

		// },
	},
	created() {
		// this.fetchDataList(val);
	},
	mounted() {
		let _id = '';
		// this.$nextTick(() => {
		// 	this.getTagList();
		// });
		setTimeout(() => {
			this.getTagList();
		}, 500);
		this.fetchAreaData(_id);
		// this.fetchDataList(this.currentChoose);
		setTimeout(() => {
			$('.el-range-editor--small.el-input__inner').css(
				'border',
				'1px solid #F3F3F3'
			);
			$('.el-pagination__editor.el-input .el-input__inner').css(
				'border',
				'1px solid #E6E6E6!important'
			);

			this.keyword = '';
			// this.fetchDataList();
		}, 400);
	},
	methods: {
		//点击显示隐藏国家高度，默认只显示第一行
		showHideBox() {
			$('.m1_top_rbox').css('height', 'auto');
		},
		//获取数据列表
		fetchAreaData(id) {
			let _this = this;
			api.getAreaData(id).then((res) => {
				if (res.data) {
					_this.areaData = res.data;
					_this.chooseArea = res.data[0].childList
						? res.data[0].childList
						: [];
				}
			});
		},
		getTagList() {
			api.getDynamicInfoTagsList().then((res) => {
				if (res.data) {
					this.tagsLists = res.data;
					this.setQueryParams();
				}
			});
		},
		//获取数据列表
		fetchDataList() {
			let params = {
				code: this.treeString ? this.treeString : 'A606',
				pagesize: this.pagesize,
				currpage: this.currentPage,
				labels: this.setformattedString(),
			};
			this.loading = true; //表格加载
			api.getAcademicDocList(params).then((res) => {
				if (res.data) {
					this.dataList = res.data.data;
					this.total = res.data.totlalCount;
					this.loading = false; //表格加载
				} else {
					this.dataList = [];
					this.total = 0;
					this.loading = false; //表格加载
				}
			});
		},
		setformattedString() {
			let tagTypes = {
				country: [],
				province: [],
				industry: [],
				year: [],
			};
			for (let index = 0; index < this.selectedTags.length; index++) {
				const element = this.selectedTags[index];
				const type = element.type;
				const name = element.name;

				if (name === '不限') {
					tagTypes[type] = [];
				} else {
					tagTypes[type].push(name);
				}
			}
			// 拼接成指定格式的字符串
			let formattedString = [];
			if (tagTypes.country.length > 0) {
				formattedString.push(tagTypes.country.join(','));
			}
			if (tagTypes.province.length > 0) {
				formattedString.push(tagTypes.province.join(','));
			}
			if (tagTypes.industry.length > 0) {
				formattedString.push(tagTypes.industry.join(','));
			}
			if (tagTypes.year.length > 0) {
				formattedString.push(
					tagTypes.year.join(',').replace('年及', '')
				);
			}

			formattedString = formattedString.join('|');
			return formattedString ? formattedString : '';
		},
		//翻页
		handleCurrentChange(val) {
			this.currentPage = val;
			this.fetchDataList();
		},
		setQueryParams() {
			if (
				this.$route.query &&
				this.$route.query.tagType &&
				this.$route.query.tagName
			) {
				this.handleTagClick({
					name: this.$route.query.tagName,
					type: this.$route.query.tagType,
				});
			}
		},
		// 处理标签点击事件
		handleTagClick(tag) {
			// 根据点击的标签找到对应的标签组
			const tagList = this.tagsLists.find((list) =>
				list.tags.some(
					(t) => t.name === tag.name && t.type === tag.type
				)
			);
			//console.log(tagList);
			if (tagList) {
				if (tag.name === '不限') {
					// 如果点击的是 "不限" 标签，则选中对应类型的 "不限" 标签
					this.selectedTags = this.selectedTags.filter(
						(t) => t.type !== tag.type
					); // 先移除同类型的其他 "不限" 标签
					this.selectedTags.push({ name: '不限', type: tag.type }); // 添加当前选中的 "不限" 标签
				} else {
					// 如果点击的是其他标签，则根据当前选中状态进行添加或移除操作
					const index = this.selectedTags.findIndex(
						(t) => t.name === tag.name && t.type === tag.type
					);
					if (index !== -1) {
						this.selectedTags.splice(index, 1); // 移除已选中的标签
					} else {
						// 添加当前选中的标签
						this.selectedTags.push(tag);
					}

					// 移除当前标签组的 "不限" 标签
					const noLimitTag = tagList.tags.find(
						(t) => t.name === '不限'
					);
					if (noLimitTag) {
						const noLimitIndex = this.selectedTags.findIndex(
							(t) => t.name === '不限' && t.type === tag.type
						);
						if (noLimitIndex !== -1) {
							this.selectedTags.splice(noLimitIndex, 1);
						}
					}
				}

				// 检查当前标签组是否还有其他选中标签，如果没有则重新选中对应类型的 "不限" 标签
				const otherTagsSelected = tagList.tags.some(
					(t) =>
						t.name !== '不限' &&
						this.selectedTags.some(
							(selected) =>
								selected.name === t.name &&
								selected.type === t.type
						)
				);
				if (!otherTagsSelected) {
					const noLimitTag = tagList.tags.find(
						(t) => t.name === '不限'
					);
					if (noLimitTag) {
						const noLimitIndex = this.selectedTags.findIndex(
							(t) => t.name === '不限' && t.type === tag.type
						);
						if (noLimitIndex === -1) {
							this.selectedTags.push({
								name: '不限',
								type: tag.type,
							});
						}
					}
				}
			}

			this.fetchDataList();
		},

		// 移除标签
		removeTag(tag) {
			// 根据移除的标签找到对应的标签组
			const tagList = this.tagsLists.find((list) =>
				list.tags.some(
					(t) => t.name === tag.name && t.type === tag.type
				)
			);

			if (tagList) {
				if (tag.name === '不限') {
					return; // 不执行移除操作
				}
				const index = this.selectedTags.findIndex(
					(t) => t.name === tag.name && t.type === tag.type
				);
				if (index !== -1) {
					this.selectedTags.splice(index, 1); // 移除选中的标签
				}

				// 如果当前标签组没有其他选中标签，则重新选中对应类型的 "不限" 标签
				const noLimitTag = tagList.tags.find((t) => t.name === '不限');
				if (
					noLimitTag &&
					this.selectedTags.filter((t) => t.type === tag.type)
						.length === 0
				) {
					this.selectedTags.push({
						name: '不限',
						type: noLimitTag.type,
					});
				}
			}
			this.fetchDataList();
		},
	},
	filters: {
		subData1(value) {
			return value.substring(0, 7);
		},
		subData2(value) {
			return value.substring(8, 10);
		},
	},
};
</script>

<style scoped lang="less">
.model1 {
	height: 100%;
	overflow: hidden;
}
.model1_box1 {
	width: 890px;
	min-height: 185px;
	background: #fff;
	padding: 14px 30px;
	margin-bottom: 20px;
	overflow: hidden;
}
.model1_box2 {
	background: #fff;
	width: 890px;
	padding: 0 30px 14px;
}

.m1_info_box {
	width: 100%;
	overflow: hidden;
	position: relative;
}
.m1_info_box h5 {
	width: 100%;
	height: 70px;
	line-height: 70px;
	border-bottom: 1px solid #e7ede5;
	font-size: 16px;
	font-family: Source Han Sans CN;
	font-weight: 500;
	color: #222222;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	-o-text-overflow: ellipsis;
	margin-top: 10px;
}
.m1_info_box h5 img {
	height: 18px;
	display: inline-block;
	margin-right: 5px;
	vertical-align: middle;
}

.m1_info_ul {
	width: 100%;
	overflow: hidden;
}
.m1_info_ul li {
	width: 100%;
	height: 77px;
	border-bottom: 1px solid #e7ede5;
	padding: 30px 0;
	cursor: pointer;
}

.m1_info_li_l {
	width: 126px;
	height: 100%;
	text-align: center;
	float: left;
	border-right: 1px solid #f3f3f3;
}
.m1_info_li_l h6 {
	font-size: 22px;
	font-family: Arial;
	font-weight: 400;
	color: #1b1b1b;
	width: 100%;
	text-align: center;
}
.m1_info_li_l span {
	width: 100%;
	display: block;
	text-align: center;
	font-size: 14px;
	color: #999;
}
.m1_info_li_r {
	padding-left: 36px;
	float: left;
	width: 625px;
}
.m1_info_li_r h6 {
	font-size: 18px;
	font-family: Source Han Sans CN;
	font-weight: 500;
	color: #4d4d4d;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	-o-text-overflow: ellipsis;
	margin-bottom: 6px;
}
.m1_info_li_r h6:hover {
	color: #4eac41;
}
.m1_info_li_r span {
	display: block;
	width: 100%;
	line-height: 24px;
	font-size: 14px;
	font-family: Source Han Sans CN;
	font-weight: 400;
	color: #808080;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2;
	overflow: hidden;
}

.pagination_box {
	width: 100%;
	overflow: hidden;
	margin-bottom: 70px;
	margin-top: 50px;
	text-align: right;
}

.m1_top_box {
	width: 100%;
	overflow: hidden;
}
.m1_top_lbox {
	width: 70px;
	float: left;
}
.m1_top_lbox span {
	width: 100%;
	display: block;
	text-align: center;
	font-size: 14px;
	font-family: Source Han Sans CN;
	font-weight: bold;
	color: #191919;
}
.m1_top_rbox {
	width: 700px;
	height: 30px;
	float: left;
	position: relative;
}
.m1_top_rbox span {
	font-size: 14px;
	font-family: Source Han Sans CN;
	font-weight: 400;
	color: #222222;
	margin-right: 20px;
	margin-bottom: 12px;
	cursor: pointer;
	display: inline-block;
}
.el-range-editor--small.el-input__inner {
	border: 1px solid #e7ede5 !important;
}
.m1_top_rbox span.active {
	color: #4eac41;
}
.selected-tags {
	min-height: 37px;
	margin-top: 10px;
	display: flex;
	align-items: center;
	overflow: hidden;
	.tagListTitle {
		font-size: 14px;
		font-weight: 600;
		min-width: 50px;
	}
	.el-tag {
		margin: 5px 10px 5px 0;
		font-size: 14px;
		background: transparent;
		border: 1px solid #f6ad3c;
		// color: #f6ad3c !important;
		height: 27px;
		line-height: 26px;
		.el-tag__close {
			color: red !important;
		}
		.el-icon-close {
			color: red !important;
		}
	}
}
.downPull {
	border-bottom: 1px dashed #ccc;
}
</style>



// WEBPACK FOOTER //
// src/view/dynamicInfo/modes.vue